import { useGlobalContext } from "context/global/state";
import React, { ReactNode, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { PageContext } from "types/pageContext";
import HorizonFooter from "../../../components/layout/footer/mainFooter";
import PdsFooter from "../../../components/layout/footer/pdsFooter";
import MainMenuController from "../elements/menu/menuController";
import SecondaryMenuController from "../elements/secondaryMenu/secondaryMenuController";
import useTemplateController from "../hooks/useTemplateController";

type PagesContainerTemplateControllerProps = {
	children?: ReactNode;
};

const PagesContainerTemplateController: React.FC<PagesContainerTemplateControllerProps> =
	({ children }) => {
		// Handles any other configuration needed (ex: setting the title)
		useTemplateController();

		const { dispatch } = useGlobalContext();
		const history = useHistory();

		useEffect(() => {
			const config: PageContext = { pathname: history.location.pathname };
			dispatch({ type: "pageContext", config });
			const listener = history.listen((event) => {
				const config: PageContext = {
					pathname: event.pathname,
					activeLink: "",
				};
				dispatch({ type: "pageContext", config });
			});
			return () => {
				listener();
			};
		}, [history, dispatch]);

		const footer = (
			<>
				<PdsFooter />
				<HorizonFooter />
			</>
		);

		return (
			<>
				<MainMenuController />
				<SecondaryMenuController />
				{children}
				{footer}
			</>
		);
	};

export default PagesContainerTemplateController;
